import api from '@services/api';
import { FileResponse, PeriodFileExportRequest } from '../models/periodFile';

/**
 * <p>
 * API endpoints that cover all resource project related CRUD calls
 */

export const periodFile = api.injectEndpoints({
  endpoints: (builder) => ({
    // POST
    exportFiles: builder.mutation<void, PeriodFileExportRequest>({
      query: (input) => ({
        url: encodeURI(`/salary/period-file/export?period=${input.date}&projectCode=${input.projectCode}`),
        method: 'POST',
      }),
      invalidatesTags: ['PeriodFileByPeriod'],
    }),
    // GET
    periodFileByPeriod: builder.query<FileResponse, number>({
      query: (periodId: number) => ({
        url: encodeURI(`/salary/period-file/byPeriod?periodId=${periodId}`),
        method: 'GET',
      }),
      providesTags: ['PeriodFileByPeriod'],
    }),
  }),
});

export const { useExportFilesMutation, usePeriodFileByPeriodQuery } = periodFile;
